module.exports = __webpack_public_path__ + "static/Cinzel-Regular-39be2384867d34a46f5c9c62ed495174.ttf";